import styled from 'styled-components';

import { HorizontalCenterBlock, VerticalHorizontalCenterColumnBlock } from '../../../styled';

export const EnterpriseFieldWrapper = styled.div`
  width: 100%;
`;

export const NotificationLink = styled.a`
  color: ${(props) => props.theme.colors.brand};
  text-decoration: underline;
`;

export const Wrapper = styled(VerticalHorizontalCenterColumnBlock)`
  width: 100%;
`;

export const BlockWrapper = styled(HorizontalCenterBlock)`
  flex-direction: column;
  max-width: 468px;
`;

export const MapDivider = styled.div`
  width: 3%;
  margin: 0 10px;
  height: 1px;
  border: none;
  background-color: #c5d0db;
  position: relative;
`;

export const MapWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const MappingInputWrapper = styled.div`
  width: 100%;
`;

export const CustomizationColorInputWrapper = styled.div`
  margin-top: 8px;
  max-width: 200px;
`;

export const HiddenWrapper = styled.div`
  display: none;
`;

export const CodeWrapper = styled.div`
  border: 1px solid ${(props) => props.theme.colors.stroke};
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
`;
